import React, { useState } from 'react';
import { Card } from '../../../../components/Card/Card';
import { Order, updateOrder } from '../../../../model/order';
import { SortableList } from '../../../../components/SortableList/SortableList';
import { FormattedAddress } from '../../../../components/Address/Address';
import { t } from '../../../../locales/translate';
import { ControlledModal } from '../../../../components/Modal/ControlledModal';
import { EditOrderUser } from '../OrdersList/AddUsersToOrder';
import { Icon } from '../../../../components/Icon/Icon';
import { useConfirmation } from '../../../../components/ConfirmationPrompt/ConfirmationPrompt';
import { Address, addressPresence } from '../../../../model/company';

interface Props {
  order: Order;
}

export function UserDetails({ order }: Props): JSX.Element | null {
  const [displayUsersModal, setDisplayUsersModal] = useState(false);

  const { confirm } = useConfirmation({
    title: t.actions.delete(t.model.user._name),
    message: t.general.confirmDelete(t.model.user._name),
    action: async () => {
      await updateOrder({
        orderId: order.id,
        userId: null,
      });
    },
  });

  if (order.company) {
    return null;
  }

  const shippingAddress: Address | null =
    addressPresence(order.preferredShippingAddress) ?? addressPresence(order.deliveries.map((e) => e.address)[0]);
  const billingAddress: Address | null =
    addressPresence(order.preferredBillingAddress) ?? addressPresence(order.invoices.map((e) => e.address)[0]);

  return (
    <>
      <Card
        title={order.user?.email}
        elevation={2}
        fullbleed
        actions={
          <>
            <Icon
              name="edit"
              onClick={() => {
                setDisplayUsersModal(true);
              }}
            ></Icon>
            <Icon onClick={confirm} name="trash--sm"></Icon>
          </>
        }
      >
        <SortableList
          className="order-details__user-table"
          items={[order]}
          columns={[
            {
              dataKey: 'invoices',
              label: t.model.order.invoiceAddress,
              cellRenderer: () => (billingAddress ? <FormattedAddress address={billingAddress} /> : '-'),
            },
            {
              dataKey: 'deliveries',
              label: t.model.order.shippingAddress,
              cellRenderer: () => (shippingAddress ? <FormattedAddress address={shippingAddress} /> : '-'),
            },
          ]}
        />
      </Card>
      <ControlledModal<Order>
        open={displayUsersModal}
        model={order}
        onClose={() => {
          setDisplayUsersModal(false);
        }}
        title={t.model.order.addUserToOrder}
        size="small"
      >
        {(controller) => <EditOrderUser controller={controller} />}
      </ControlledModal>
    </>
  );
}
